export default __webpack_public_path__ + "static/media/close-icon.8a49e2f5.svg";